/** @jsxImportSource @emotion/react */
"use client";

import { Box, Typography, Button } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import SecurityIcon from "@mui/icons-material/Security";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { famentoShopierAdd } from "@/constants/texts/contact";
import {
  ctaSection,
  ctaContent,
  ctaButton,
  featuresGrid,
  featureCard,
  featureIcon,
  featureTitle,
  featureDescription,
} from "./styles";

const HomeCtaBanner = () => {
  return (
    <Box css={ctaSection}>
      <Box css={ctaContent}>
        <Typography
          variant="h2"
          color="primary.main"
          gutterBottom
          sx={{ fontWeight: 700, fontSize: { xs: "2rem", md: "2.5rem" } }}
        >
          Famento ile Evinize Sanat Katın
        </Typography>
        <Typography
          variant="body1"
          color="primary.main"
          sx={{
            fontSize: { xs: "1rem", md: "1.125rem" },
          }}
        >
          El yapımı dekoratif ürünlerimizi Shopier güvencesiyle satın
          alabilirsiniz. Shopier, Türkiye&apos;nin en çok kullanılan online
          satış platformlarından biridir.
        </Typography>

        <Box css={featuresGrid}>
          <Box css={featureCard}>
            <SecurityIcon color="primary" css={featureIcon} />
            <Typography variant="body2" color="primary.main" css={featureTitle}>
              Güvenli Ödeme
            </Typography>
            <Typography
              variant="caption"
              color="primary.main"
              css={featureDescription}
            >
              Kredi kartı, banka kartı
            </Typography>
          </Box>

          <Box css={featureCard}>
            <LocalShippingIcon color="primary" css={featureIcon} />
            <Typography variant="body2" color="primary.main" css={featureTitle}>
              Hızlı Kargo
            </Typography>
            <Typography
              variant="caption"
              color="primary.main"
              css={featureDescription}
            >
              Hızlı teslimat seçeneği
            </Typography>
          </Box>

          <Box css={featureCard}>
            <SupportAgentIcon color="primary" css={featureIcon} />
            <Typography variant="body2" color="primary.main" css={featureTitle}>
              Müşteri Desteği
            </Typography>
            <Typography
              variant="caption"
              color="primary.main"
              css={featureDescription}
            >
              Kolay iade ve destek
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="body1"
          color="primary.main"
          sx={{
            fontSize: { xs: "1rem", md: "1.125rem" },
          }}
        >
          Koleksiyonumuzu inceleyin, beğendiğiniz ürünü Shopier mağazamız
          üzerinden güvenle sipariş edin.
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          target="_blank"
          href={famentoShopierAdd}
          css={ctaButton}
          startIcon={<StorefrontIcon />}
        >
          SHOPIER&apos;da Satın Al
        </Button>
      </Box>
    </Box>
  );
};

export default HomeCtaBanner;
